import { Button, FlagHollowSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import { flagIconCss } from "./QuestionFlagButton.style";

const propTypes = {
  activityType: PropTypes.string,
  handleOnClick: PropTypes.func,
  levelId: PropTypes.string,
  objectId: PropTypes.string,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const QuestionFlagButton = ({
  activityType,
  handleOnClick,
  levelId,
  objectId,
}) => {
  const objectType =
    activityType === "quiz"
      ? objectTypes.quizQuestion
      : objectTypes.articleWord;

  const eventProperties = {
    actionName: actionNames.flag,
    actionPrefix: actionPrefixes.initiate,
    objectType,
    streamProperties: {
      component_type: "QuestionFlagButton",
      content_id: levelId,
      content_type: "Article",
      description: "Open quiz question flagging form",
      object_id: objectId,
      object_type: objectType,
    },
  };

  return (
    <ButtonWithTrackEvent
      {...eventProperties}
      __cssFor={{
        Icon: {
          root: flagIconCss,
        },
      }}
      icon={{
        SvgComponent: FlagHollowSVG,
        alignment: Button.iconAlignments.left,
      }}
      flavor={Button.flavors.secondary}
      isFullWidth
      onClick={handleOnClick}
    >
      Report question
    </ButtonWithTrackEvent>
  );
};

QuestionFlagButton.propTypes = propTypes;

export default QuestionFlagButton;
